import { Box, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import CustomReactSelect from '../../../components/custom-react-select/CustomReactSelect';
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../components/modal/CustomModal';
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect';
import PendingPatientList from '../../../components/pending-patient-list/PendingPatientList';
import RegisterHeader from '../../../components/register-header/RegisterHeader';
import RegisterNotificationBell from '../../../components/notification/RegisterNotificationBell';
import { useNotificationAccept } from '../../../components/notification/useNotificationAccept';
import { AppMisc } from '../../../misc/appMisc';
import { ERROR, PHYSIO_THERAPY_TYPE, PHYSIOTHERAPY, REQUIRED_FIELD, SOMETHING_WENT_WRONG, SUCCESS, NOTIFICATION_ACCEPTED } from '../../../utils/constants';
import { MUL_DARTA_NUMBERS_LIST } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import { SessionStorage } from '../../../utils/storage/sessionStorage';
import PhysiotherapyRegister from '../../users/components/register/physiotherapy-register/PhysiotherapyRegister';

const PhysiotherapyForm = () => {

  const [modalTitle, setModalTitle] = useState("फिजियोथेरापी सेवा नयाँ रेकर्ड थप्नुहोस्।");
  const [showPhysioTherapyModal, setShowPhysioTherapyModal] = useState(false)
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [physiotherapyDataTable, setPhysiotherapyDataTable] = useState([]);
  const { register, handleSubmit, setValue, trigger, clearErrors, formState: { errors }, reset, watch } = useForm();
  const [totalSize, setTotalSize] = useState();
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [showPhysioTherapyDeleteModal, setShowPhysioTherapyDeleteModal] = useState(false);
  const [physioTherapyDeleteId, setPhysioTherapyDeleteId] = useState(null);
  const [pendingPatientList, setPendingPatientList] = useState([])
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowPhysioTherapyModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      return data;
    },
  });

  const watchFields = watch("physioTherapyType")

  const openPhysioTherapyModal = () => {
    reset({
      referredIn: "",
      referredOut: "",
      physioTherapyType: "",
      others: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
    });
    clearErrors();
    setShowPhysioTherapyModal(true);
  }

  const closePhysioTherapyModal = () => {
    reset({
      referredIn: "",
      referredOut: "",
      physioTherapyType: "",
      others: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
    });
    setShowPhysioTherapyModal(false);
    setModalDefaultValues()
  }



  useEffect(() => {
    if (fromDate && toDate) {
      getPhysioTherapyData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getPhysioTherapyData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.physiotherapySewaRegister}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setPhysiotherapyDataTable(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const submitPhysioTherapyRegister = (data) => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.physiotherapySewaRegister, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closePhysioTherapyModal();
          physiotherapyPendingPatient()
          getPhysioTherapyData(fromDate, toDate)
          if (isFromNotification) {
            AddAlertMessage({ type: SUCCESS, message: NOTIFICATION_ACCEPTED });
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getPhysioTherapyData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const physioTherpyEdit = (id) => {
    AHMIS.get(API_URL.physiotherapySewaRegister + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        data.physioTherapyType = AppMisc.getLabelFromValues(PHYSIO_THERAPY_TYPE, data.physioTherapyType);
        setModalDefaultValues(data);
        setShowPhysioTherapyModal(true);
        if (data) {
          Object.keys(data).forEach((key) => setValue(key, data[key]));
        }
      })
      .catch(() => AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG }));
  };

  const handleSelectChange = (name, value) => {
    if (name === "physioTherapyType") {
      const selectedValue = PHYSIO_THERAPY_TYPE.flatMap((type) =>
        type.options
      ).find((option) => option.label === value)?.value ?? value;
      setValue(name, selectedValue);

    } else {
      setValue(name, value);
    }
  };

  const closePhysioTherapyDeleteModal = () => {
    setShowPhysioTherapyDeleteModal(false);
    setPhysioTherapyDeleteId(null);
  }

  const onDeletePhysioTherapyRow = (id) => {
    setShowPhysioTherapyDeleteModal(true);
    setPhysioTherapyDeleteId(id);
  }

  const deletePhysioTherapyeRow = (data) => {
    AHMIS.delete(API_URL.physiotherapySewaRegister + "/" + physioTherapyDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowPhysioTherapyDeleteModal(false);
          setPhysioTherapyDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getPhysioTherapyData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=8&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }


  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  useEffect(() => {
    physiotherapyPendingPatient()
  }, [])

  const physiotherapyPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"8"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${PHYSIOTHERAPY}`;
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setPendingPatientList(jsondata.data);
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="फिजियोथेरापी सेवा रजिष्टर"
          handleModalOpen={openPhysioTherapyModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getPhysioTherapyData}
          lazyLoading
          showSearchField
          rightElement={<RegisterNotificationBell targetRegister={PHYSIOTHERAPY} onAccept={handleNotificationAccept} />}
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showPhysioTherapyModal}
        onModalSubmit={handleSubmit(submitPhysioTherapyRegister)}
        onModalClose={closePhysioTherapyModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            registerConstant={PHYSIOTHERAPY}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई आएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredIn"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredIn}
                fullWidth
                {...register("referredIn")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई गएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredOut"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredOut}
                fullWidth
                {...register("referredOut")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="फिजियोथेरापी सेवा प्रकार"
                name="physioTherapyType"
                variant="outlined"
                options={PHYSIO_THERAPY_TYPE}
                onChange={handleSelectChange}
                defaultValue={modalDefaultValues?.physioTherapyType}
                register={register}
                required
              />
              {errors?.physioTherapyType && errors.physioTherapyType?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            {watchFields?.includes("OTHER") && (
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="अन्य"
                  size="small"
                  variant="outlined"
                  name="others"
                  autoComplete="true"
                  defaultValue={modalDefaultValues?.others}
                  fullWidth
                  {...register("others")}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList?.size > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowPhysioTherapyModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showPhysioTherapyDeleteModal}
        closeDeleteModel={closePhysioTherapyDeleteModal}
        deleteRecord={deletePhysioTherapyeRow}
      />
      <PhysiotherapyRegister
        onEditRow={physioTherpyEdit}
        tableData={physiotherapyDataTable}
        deleteRow={onDeletePhysioTherapyRow}
        totalSize={totalSize}
      />
    </>
  )
}

export default PhysiotherapyForm
